var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoEnvirontmentOthers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76.5 104.9",
    style: {
      enableBackground: "new 0 0 76.5 104.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 38.3,
    cy: 47.4,
    rx: 10.1,
    ry: 10.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M18.1,66.2 c-3.5-4.4-5.6-10-5.6-16C12.5,36,24,24.5,38.2,24.5S63.9,36,63.9,50.2c0,6.1-2.1,11.6-5.6,16"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#069AB3"
    },
    cx: 38.2,
    cy: 24.4,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#79BF43"
    },
    cx: 64,
    cy: 47.4,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E1E433"
    },
    cx: 12.5,
    cy: 47.4,
    r: 6.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#069AB3"
    },
    d: "M38.3,66.6l-4.8-6.4h-9.1v26.9h15.3h8.1c2.4,0,4.4-2,4.4-4.4v-6.6V60.2h-9L38.3,66.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 38.3,
    cy: 47.4,
    rx: 10.1,
    ry: 10.1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M38.3,66.6l-4.8-6.4h-9.1v26.9h15.3h8.1 c2.4,0,4.4-2,4.4-4.4v-6.6V60.2h-9L38.3,66.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 38.2,
    cy: 24.4,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 64,
    cy: 47.4,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#233F94",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    cx: 12.5,
    cy: 47.4,
    r: 6.5
  })), /*#__PURE__*/React.createElement("rect", {
    y: 14.2,
    style: {
      fill: "none"
    },
    width: 76.5,
    height: 76.5
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEnvirontmentOthers);
export default __webpack_public_path__ + "static/media/ico-Environtment-Others.f6c11cf1964428ed818627803a17553c.svg";
export { ForwardRef as ReactComponent };